<template>
  <div class="entry" @click="$emit('selected')">
    <div class="row space-between">
      <div class="entry-title">{{entry.title}}</div>
      <div class="small">{{date}}</div>
    </div>
    <div class="entry-text small-top">
      {{entry.text}}
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["entry"],
  computed: {
    date() {
      return moment(this.entry.created_at).format("ll");
    }
  }
}
</script>

<style lang="less" scoped>
.entry {
  color: white;
  border-bottom-color: white;
  border-bottom-width: 1px;
  border-bottom-style: solid;

  .entry-title {
    font-weight: 800;
    font-size: 15px;
  }

  .small {
    font-size: 12px;
    opacity: .7;
  }

  .entry-text {
    overflow: hidden;
    line-height: 15px;
    max-height: 30px;
    .small;
  }
}

</style>
